import Vue from 'vue'

Vue.mixin({
  computed: {
    isSm() {
      return window.matchMedia('(max-width: 540px)').matches
    },
    isMd() {
      return window.matchMedia('(max-width: 720px)').matches
    },
    isMdOrHigher() {
      return window.matchMedia('(min-width: 720px)').matches
    },
    isLg() {
      return window.matchMedia('(max-width: 960px)').matches
    },
    isXl() {
      return window.matchMedia('(min-width: 1140px)').matches
    },
  }
})